<template>
  <div class="create-project flex-column scroll">
    <div class="flex-column format-screen">
      <!-- <ProjectProgress ref="ProjectProgress" :project="project" :company="company" @showConfirmDialog="showConfirmDialog"></ProjectProgress> -->
      <div ref="navTopContent" class="content-box">
        <div class="left-box">
          <ClientCompanyDetail
            ref="ClientCompanyDetail"
            :company="company"
            class="create-project-item"
          ></ClientCompanyDetail>

          <el-card
            ref="navigator"
            :class="'navigator ' + (navFixed ? 'nav-fixed' : '')"
            body-style="display:flex;padding:0"
            shadow="never"
          >
            <div class="navigator-title">
              <span>重要导航</span> <b> <i class="el-icon-arrow-right"></i> </b>
            </div>
            <div class="button-wrap">
              <el-button
                v-for="nav in navs"
                :key="nav.ref"
                size="small"
                class="custom-primary-plain"
                :type="nav.label === '推荐须知' ? 'danger' : 'primary'"
                plain
                @click="jumpTo(nav)"
                >{{ nav.label }}</el-button
              >
            </div>
          </el-card>
          <div v-if="navFixed" :style="'margin-bottom:10px;width:1px;height:' + navigatorHeight + 'px'"></div>

          <RadishPicAnalyse
            ref="RadishPicAnalyse"
            :project="project"
            :company="company"
            class="create-project-item"
          ></RadishPicAnalyse>
          <ClientBackground
            ref="ClientBackground"
            :project="project"
            :company="company"
            class="create-project-item"
          ></ClientBackground>

          <!-- <ProjectBasicInfo
            ref="ProjectBasicInfo"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            style="display:flex"
            class="create-project-item"
            @modifyProject="modifyProject"
            @getNewCompany="getNewCompany"
          ></ProjectBasicInfo> -->
          <JobJd
            ref="JobJd"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></JobJd>
          <!-- <CoreRequirement
            ref="CoreRequirement"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></CoreRequirement> -->
          <JobRequirement
            ref="JobRequirement"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></JobRequirement>
          <Advantage
            ref="Advantage"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></Advantage>
          <InterviewCoach
            ref="InterviewCoach"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></InterviewCoach>
          <OrderAnalyze
            ref="OrderAnalyze"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></OrderAnalyze>
          <!-- <ClientCompany
            ref="ClientCompany"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></ClientCompany> -->
          <ProjectGrade ref="ProjectGrade" style="margin-bottom:16px;" :project="project" :company="company">
          </ProjectGrade>
        </div>
        <div class="right-box">
          <ProjectMember
            ref="ProjectMember"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></ProjectMember>
          <!-- <RadishPic
            ref="RadishPic"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></RadishPic> -->
          <SearchRequirement
            ref="SearchRequirement"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></SearchRequirement>
          <ProjectRecord
            ref="ProjectRecord"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></ProjectRecord>
          <!-- 项目阶段进展汇总 -->
          <el-card ref="ProjectStep" class="create-project-item" body-style="padding:0px 20px 10px;">
            <h3 class="common-title mb10">项目阶段进展汇总</h3>
            <div class="context" style="max-height:500px;overflow:auto">
              <ProjectSteps :project="project"></ProjectSteps>
            </div>
          </el-card>
          <Attachment
            ref="Attachment"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></Attachment>
          <ProjectCoach
            ref="ProjectCoach"
            :project="project"
            :company="company"
            :has-not-value-fields="hasNotValueFields"
            class="create-project-item"
            @modifyProject="modifyProject"
          ></ProjectCoach>
          <!-- 失败人选 -->
          <el-card
            v-if="finalRadishes.length > 0"
            ref="FinalRadishes"
            body-style="padding:0px 20px 10px"
            class="create-project-item"
          >
            <h3 class="common-title mb10">失败人选</h3>
            <div class="">
              <div v-for="(item, index) in finalRadishes" :key="`finalRadish${index}`" class="mr10 mb5">
                <p>
                  <span>入职人选：</span
                  ><span class="drawer-link mr10" @click="showRadish(item._id)">{{ item.姓名 }}</span>
                  <span>人选来源：</span><span>{{ project.finalRadishFrom }}</span>
                </p>
                <p>失败原因：{{ project.failReason }}</p>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <el-backtop target=".project-nav-tabs .el-tabs__content" :right="18" :bottom="64">
        <el-tooltip class="item" effect="dark" content="返回顶部" placement="left">
          <el-button type="primary" icon="el-icon-caret-top" circle plain></el-button>
        </el-tooltip>
      </el-backtop>

      <ConfirmDialog ref="ConfirmDialog" :project="project" :company="company" @toEdit="toEdit"> </ConfirmDialog>
      <SimilarProjectDialog ref="SimilarProjectDialog"> </SimilarProjectDialog>
    </div>
  </div>
</template>
<script>
// import ProjectBasicInfo from './ProjectBasicInfo'
import JobJd from './JobJd'
// import CoreRequirement from './CoreRequirement'
import Advantage from './Advantage'
import SearchRequirement from './SearchRequirement'
// import RadishPic from './RadishPic'
import ProjectMember from './ProjectMember'
// import ClientCompany from './ClientCompany'
import ProjectCoach from './ProjectCoach'
import InterviewCoach from './InterviewCoach'
import OrderAnalyze from './OrderAnalyze'
import Attachment from './Attachment'
import ProjectGrade from '../ProjectGrade'
import ProjectRecord from './ProjectRecord'
// import ProjectProgress from './ProjectProgress'
import ProjectSteps from '../projectProgress/ProjectSteps'
import ConfirmDialog from './ConfirmDialog'
import ClientCompanyDetail from './ClientCompanyDetail'
import RadishPicAnalyse from './RadishPicAnalyse'
import ClientBackground from './ClientBackground'
import JobRequirement from './JobRequirement'
import SimilarProjectDialog from './SimilarProjectDialog'

import { defaultProject, defaultCompany } from '../../constant/defaultData'

const navs = [
  { label: '推荐须知' },
  { label: '人才画像', ref: 'JobRequirement' },
  { label: '问答反馈', ref: 'ProjectCoach' },
  { label: '客户详情', ref: 'ClientBackground' },
  { label: '寻访方向', ref: 'SearchRequirement' },
  { label: '必成单分析', ref: 'OrderAnalyze' },
  { label: '相似岗位' },
  { label: '岗位JD', ref: 'JobJd' },
  // { label: '项目基本信息', ref: 'ProjectBasicInfo' },
  // { label: '职位JD', ref: 'JobJd' },
  // { label: '核心要求', ref: 'CoreRequirement' },
  // { label: '亮点优势', ref: 'Advantage' },
  // { label: '寻访要求', ref: 'SearchRequirement' },
  // { label: '人才画像', ref: 'RadishPic' },
  // { label: '项目成员', ref: 'ProjectMember' },
  // { label: '客户公司信息', ref: 'ClientCompany' },
  // { label: '项目辅导', ref: 'ProjectCoach' },
  // { label: '面试辅导', ref: 'InterviewCoach' },
  // { label: '必成单分析', ref: 'OrderAnalyze' },
  // { label: '附件', ref: 'Attachment' },
  // { label: '项目阶段进展汇总', ref: 'ProjectStep' },
]
export default {
  components: {
    // ProjectBasicInfo,
    JobJd,
    // CoreRequirement,
    Advantage,
    SearchRequirement,
    // RadishPic,
    ProjectMember,
    // ClientCompany,
    ProjectCoach,
    InterviewCoach,
    OrderAnalyze,
    Attachment,
    ProjectGrade,
    ProjectRecord,
    // ProjectProgress,
    ProjectSteps,
    ConfirmDialog,
    ClientCompanyDetail,
    RadishPicAnalyse,
    ClientBackground,
    JobRequirement,
    SimilarProjectDialog,
  },
  props: {
    projectId: { type: String, default: undefined },
  },
  data() {
    return {
      navs: navs,
      project: window._.cloneDeep(defaultProject),
      company: {},
      hasNotValueFields: [],
      navFixed: false,
      navigatorHeight: 0,
      finalRadishes: [],
    }
  },
  watch: {
    projectId: {
      async handler(val, oldVal) {
        await this.loadData()
      },
      immediate: true,
    },
    // finalRadishes(val, oldVal) {
    //   if (val.length > 0) {
    //     const has = this.navs.find(v => v.label === '失败人选')
    //     if (!has) this.navs.splice(this.navs.length - 1, 0, { label: '失败人选', ref: 'FinalRadishes' })
    //   } else this.navs = this.navs.filter(v => v.label !== '失败人选')
    // },
  },
  async mounted() {
    this.navigatorHeight = this.$refs.navigator.$el.offsetHeight
    this.navFixed = false
    // this.company = window._.cloneDeep(defaultCompany)
    // const res = await app.service('company').getCompany({ 简称: '嘉实基金' })
    // if (res.status === 200) {
    //   this.getCompany(res.result)
    // } else this.company = window._.cloneDeep(defaultCompany)
  },
  methods: {
    async loadData() {
      try {
        const data = await app.service('project').fetch(this.projectId)
        if (Array.isArray(data.remark) && data.remark.length > 0) {
          data.remark.sort((a, b) => b.createAt - a.createAt)
        }
        // TODO:获取数据时，修改数据未目前的结构
        if (data.核心要求) {
          if (!Array.isArray(data.核心要求)) {
            data.核心要求 = [data.核心要求]
          }
        } else data.核心要求 = []
        if (data.管理职级) {
          if (!Array.isArray(data.管理职级)) {
            data.管理职级 = [data.管理职级]
          }
        } else data.管理职级 = []
        if (data.公司亮点及优势) data.公司优势 = data.公司亮点及优势
        if (data.可能的问题及应对) {
          if (!Array.isArray(data.可能的问题及应对)) {
            data.可能的问题及应对 = [{ Q: data.可能的问题及应对, A: '' }]
          } else {
            data.可能的问题及应对 = data.可能的问题及应对.map(v => {
              if (typeof v !== 'object') {
                return { Q: v, A: '' }
              } else return v
            })
          }
        }
        // TODO:结束

        this.project = Object.assign({}, data)
        await this.saveRecords()
        this.getProjectFiles(this.project._id)
        this.getFinalRadishes()
        this.getCompany()
        this.checkStorage()
        this.findProjectInterviews()
      } catch (error) {
        this.$message.error(`projectDetail getProject:${error.message}`)
      }
    },
    async findProjectInterviews() {
      const res = await app.service('project').findProjectInterviews(this.project._id)
      if (res.status === 'success') {
        this.$set(this.project, 'interviews', res.data)
      } else {
        this.$message.error(res.msg)
      }
    },
    async getProjectFiles(projectId) {
      if (!projectId) return this.$set(this.project, '附件', [])
      // this.filesLoading = true
      try {
        const res = await window.app.service('file').projectFiles({ query: { projectId } })
        this.$set(this.project, '附件', res.data)
        return res
      } catch (e) {
        console.error(e)
      }
      // this.filesLoading = false
    },
    async saveRecords() {
      await app
        .service('project')
        .saveRecords({ pid: this.projectId, 项目名称: this.project.项目名称, type: '查看项目' })
    },
    checkStorage() {
      const { project } = this
      const storage = localStorage.getItem('hasCheckProject')
      const obj = (storage && JSON.parse(storage)) || {}
      if (!obj[project._id]) {
        obj[project._id] = true
        localStorage.setItem('hasCheckProject', JSON.stringify(obj))
      }
    },
    async getCompany() {
      const res = await app.service('company').getCompany({ 简称: this.project.客户公司 })
      if (res.status === 200) {
        const attachmentTypes = ['公司简介', '薪酬/职级/奖金机制', '公司O-chart', '特殊要求', '推荐模版', '开票信息']
        res.result.companyAttachments = res.result.附件
        res.result.附件 = (res.result.附件 || []).filter(v => attachmentTypes.includes(v.type))
        this.company = res.result
        this.getCompanyHr()
        this.getCompanyLeaders()
      } else this.company = window._.cloneDeep(defaultCompany)
    },
    showRadish(rid) {
      if (!rid) return
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
    },
    async getFinalRadishes() {
      const ids = this.project.finalRadishIds || []
      if (ids.length === 0) return (this.finalRadishes = [])
      this.finalRadishes = await this.getRadishesByIds(ids)
    },
    async getRadishesByIds(ids) {
      const res = await app.service('radish').simpleList({
        query: { _id: { $in: ids } },
        fields: { 姓名: 1 },
      })
      return res.status === 'success' ? res.data : []
    },
    // old
    getNewCompany(company) {
      const attachmentTypes = ['公司简介', '薪酬/职级/奖金机制', '公司O-chart', '特殊要求', '推荐模版', '开票信息']
      company.companyAttachments = company.附件
      company.附件 = (company.附件 || []).filter(v => attachmentTypes.includes(v.type))
      if (!this.project.附件) this.$set(this.project, '附件', [])
      for (const atta of company.附件) {
        const copyAtta = window._.cloneDeep(atta)
        delete copyAtta._id
        copyAtta.type = '其他'
        this.project.附件.push(copyAtta)
      }
      this.company = company
      const param = this.setField2Project()
      if (Object.keys(param).length > 0) this.updateProject(param)
      this.getCompanyHr()
      this.getCompanyLeaders()
    },
    setField2Project() {
      const fields = [
        '目标公司',
        '不倾向公司',
        '倾向平台',
        '典型人才',
        '面试安排',
        '一句话简介',
        '特殊要求寻访',
        '推荐备注',
        '特殊要求面试安排',
      ]
      const specialField = { 公司亮点: ['公司优势'], 公司劣势: ['公司劣势'] }
      const translateField = { 阿尔法公司认知: '公司备注', 公司薪酬概况: '薪酬/职级/奖金机制' }
      const param = {}
      fields.forEach(field => {
        if (this.project[field] !== this.company[field]) param[field] = this.company[field]
      })
      Object.keys(translateField).forEach(field => {
        if (this.project[field] !== this.company[translateField[field]])
          param[field] = this.company[translateField[field]]
      })
      Object.keys(specialField).forEach(field => {
        const content = this.company[field] && this.company[field].content
        specialField[field].forEach(v => {
          if (this.project[v] !== content) param[v] = content
        })
      })
      const { tags, 用人偏好: companyTag } = this.company
      if (!tags || typeof tags !== 'object' || Object.keys(tags).length === 0) return param
      param['标签'] = window._.cloneDeep(this.project['标签'] || [])
      for (const type in tags) {
        tags[type].forEach(tag => {
          if (!param['标签'].includes(tag)) param.push(tag)
        })
      }
      if (companyTag && Array.isArray(companyTag['语言能力'])) {
        companyTag['语言能力'].forEach(tag => {
          if (!param['标签'].includes(tag)) param['标签'].push(tag)
        })
      }
      return param
    },
    async getCompanyHr() {
      if (!this.company.对接hr || this.company.对接hr.length === 0) return
      const res = await app.service('company').getCompanyHr(this.company.对接hr)
      if (res.status === 'success') this.company.对接hr = res.data
      else {
        this.$message.error(res.msg)
      }
    },
    async getCompanyLeaders() {
      if (!this.company.领导 || this.company.领导.length === 0) return
      const res = await app.service('company').getLeaders(this.company.领导)
      if (res.status === 'success') {
        this.company.领导 = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    modifyProject({ field, value }) {
      this.$set(this.project, field, value)
    },
    // progressJumpTo(label){
    //   const nav = navs.find(v=>v.label===label)
    //   this.jumpTo(nav.ref)
    // },
    showConfirmDialog(percent) {
      this.progressPercent = percent
      this.$refs.ConfirmDialog.open(percent)
    },
    toEdit(v) {
      this.hasNotValueFields = v
      this.jumpTo(this.navs[0])
    },
    async jumpTo(nav) {
      const label = nav.label
      await app.service('project').saveRecords({ type: label, path: '客户详情-重要导航', page: '公司详情' })
      if (label === '推荐须知') return this.$emit('showRecommendDialog')
      if (label === '相似岗位') return this.$refs.SimilarProjectDialog.open(this.project.职能模块)
      const ref = nav.ref
      this.navigatorHeight = this.$refs.navigator.$el.offsetHeight
      const navTopContentTop = this.$refs.navTopContent ? this.$refs.navTopContent.offsetTop : 0
      // TODO:ProjectProgress组件去除
      const ProjectProgressHeight = this.$refs.ProjectProgress ? this.$refs.ProjectProgress.$el.offsetHeight : 0
      const componentOffsetTop = this.$refs[ref]
        ? this.$refs[ref].$el
          ? this.$refs[ref].$el.offsetTop
          : this.$refs[ref].offsetTop
        : 0
      const transprantNavHeight = this.$refs.navigator ? this.$refs.navigator.$el.offsetHeight : 0

      this.$el.parentNode.parentNode.scrollTo({
        top: componentOffsetTop - navTopContentTop - ProjectProgressHeight - transprantNavHeight + 60,
        // top: (this.$refs[ref] ? this.$refs[ref].$el.offsetTop : 0) + this.$refs.BasicInfo.$el.offsetHeight + 20,
        behavior: 'smooth',
      })
      // this.$parent.$refs.scrollWrap.scrollTo({
      //   top: this.$refs[type].$el.offsetTop + this.$refs.BasicInfo.$el.offsetHeight + 20,
      //   behavior: 'smooth',
      // })
    },
  },
}
</script>
<style scoped>
.create-project {
  background-color: #eff2f5;
  position: relative;
}
.format-screen {
  width: 90%;
  margin: 0 auto;
}
.navigator {
  display: flex;
  align-items: center;
  border-radius: 2px;
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  transition: none;
}
.navigator-title {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 16px;
}
.navigator-title span {
  display: flex;
  font-size: 18px;
  color: #929292;
  font-weight: 600;
}
.navigator-title b {
  font-size: 26px;
  color: #929292;
}
.navigator-title b i {
  display: block;
}
.button-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.button-wrap .el-button {
  margin-right: 10px;
  margin-bottom: 5px;
  margin-top: 5px;
}
.navigator.nav-fixed {
  width: calc(90% - 8px);
  position: fixed;
  top: 137px;
  left: 50%;
  margin-left: -45%;
  z-index: 3;
}
@media screen and (max-width: 1280px) {
  .format-screen {
    width: 100%;
    margin: 0 auto;
  }
  .navigator.nav-fixed {
    width: calc(100% - 8px);
    position: fixed;
    top: 137px;
    left: 50%;
    margin-left: -50%;
    z-index: 3;
  }
}
.create-project-item {
  margin-bottom: 14px;
}
.content-box {
  display: flex;
}
.left-box {
  width: 75%;
  padding-right: 8px;
}
.right-box {
  width: 25%;
  padding-left: 8px;
}
.footer-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.common-title {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0 20px;
  position: relative;
  text-indent: 20px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}
.common-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 85%;
  width: 5px;
  background-color: #409eff;
  display: block;
}
</style>
